import * as React from 'react'

/**
 * Celdas y formateadores de tabla. Estaban duplicados dentro de `_protected/historial.tsx`;
 * se extraen aquí porque las pantallas de administración usan las mismas.
 */

export function fmt(n: number) {
  return n.toLocaleString('es-CO')
}

export function fmtDate(ts: number | null) {
  if (!ts) return '—'
  return new Date(ts).toLocaleDateString('es-CO', {
    year: 'numeric', month: '2-digit', day: '2-digit',
  })
}

export function fmtDateTime(ts: number) {
  return new Date(ts).toLocaleString('es-CO', {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit',
  })
}

/** 'YYYY-MM' → 'agosto 2025' */
export function fmtMes(mes: string) {
  const [y, m] = mes.split('-').map(Number)
  return new Date(y, m - 1, 1).toLocaleDateString('es-CO', { month: 'long', year: 'numeric' })
}

export function Th({ children, right = false }: { children?: React.ReactNode; right?: boolean }) {
  return (
    <th className={`px-3 py-2 text-xs font-semibold text-muted-foreground bg-muted border-b ${right ? 'text-right' : 'text-left'}`}>
      {children}
    </th>
  )
}

export function Td({
  children, right = false, mono = false,
}: { children: React.ReactNode; right?: boolean; mono?: boolean }) {
  return (
    <td className={`px-3 py-2 text-sm border-b ${right ? 'text-right' : ''} ${mono ? 'font-mono' : ''}`}>
      {children}
    </td>
  )
}
